import { component } from 'picoapp';
import waitFor from 'utils/wait-for';

export default component(async (node) => {
  const { productId, variantId } = node.dataset;

  const initUpdate = async () => {
    await waitFor(window, 'WishlistKing');

    const updateBtn = async () => {
      const { products } = await WishlistKing.toolkit.collection.get();
      const matchingProduct = products.find((product) => product.id === parseInt(productId, 10));
      const icons = node.querySelectorAll('.icon');

      icons.forEach((icon) => {
        icon.classList[matchingProduct ? 'add' : 'remove']('!duration-0');
      });

      node.classList[matchingProduct ? 'add' : 'remove']('wishlist-add-btn--active');
      node[matchingProduct ? 'setAttribute' : 'removeAttribute']('data-active', '');
    };

    updateBtn();
    document.addEventListener('wishlist:update', updateBtn);
  };

  const initClick = () => {
    node.addEventListener('click', async () => {
      const html = node.innerHTML;
      node.innerHTML = theme.icons.loader;

      if (!node.hasAttribute('data-active')) {
        await WishlistKing.toolkit.addProduct(productId, variantId);
      } else {
        const { products } = await WishlistKing.toolkit.collection.get();

        const { wishlist_item_id: wishlistId } = products.find((product) => (
          product.id === parseInt(productId, 10)
        ));

        await WishlistKing.toolkit.removeItem(wishlistId);
      }

      document.dispatchEvent(new Event('wishlist:update'));

      node.innerHTML = html;
    });
  };

  const init = () => {
    initUpdate();
    initClick();
  };

  init();
});
